"use client"
import { useSearchParams, usePathname, useRouter } from "next/navigation"

/**
 * Helper hook to update the URL state with a given key.
 */
export function useHandleSearchParams(queryKey: string) {
  const { push } = useRouter()

  const searchParams = useSearchParams()
  const pathname = usePathname()

  function handle(value: string, deleteAllOthers = false) {
    console.log("Pushing value")
    const params = new URLSearchParams(searchParams || "")

    if (deleteAllOthers) {
      params.forEach((_, key) => {
        if (key !== queryKey) {
          params.delete(key)
        }
      })
    }

    if (value) {
      params.set(queryKey, value)
    } else {
      params.delete(queryKey)
    }

    push(`${pathname}?${params.toString()}`)
  }

  return {
    handle,
    currentValue: searchParams?.get(queryKey),
  }
}
